/* eslint-disable react-hooks/exhaustive-deps */
import { t } from "i18next";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { LANGUAGE, MODAL_BODY, CHAT_APP } from "../../constants/constant";
import {
  getPoll,
  queueState,
  sendMessages,
  setGetPollIntervalId,
  startChat,
} from "../../redux/slices/ChatSlice/chatSlice";
import { getLanguage } from "../../util/UtilMethods";
import MessageView from "./MessageView";
import SendMessageView from "./SendMessageView";
import StatusView from "./StatusView";

const LiveChat = (props) => {
  const { setModalBody } = props;
  const [message, setMessage] = useState();

  const dispatch = useDispatch();

  const { participantId, receiveMessageList, isAgentTyping, isSessionOpen } =
    useSelector((state) => state.chat);

  const { userData } = useSelector((state) => state.form);

  useEffect(() => {
    if (isSessionOpen) {
      getQueueState();
      if (participantId === "") {
        getStartChat();
      }
    }
  }, []);

  // This useEffect will call getPoll API with interval time
  useEffect(() => {
    let intervalId = setInterval(() => {
      getReceivedMessages();
    }, 1500);
    dispatch(setGetPollIntervalId(intervalId));
  }, [participantId]);

  // This method will call questate API
 const getQueueState = () => {
     const capitalizeFirstLetter = (string) => {
         return string.charAt(0).toUpperCase() + string.slice(1);
     };

     let queueCategory = "";

     if (userData?.category === "generalInquiries") {
         if(userData?.typeOfQuery === "dubaiHealthInitiatives"){
            queueCategory = "DAHCInitiatives";
         }else{
            queueCategory = capitalizeFirstLetter(userData?.typeOfQuery || "");
         }
     } else if(userData?.category === "medicalFitness"){
         queueCategory = capitalizeFirstLetter(userData?.typeOfQuery || "");
     } else if (userData?.category === "shareFeedback") {
         queueCategory = capitalizeFirstLetter(userData?.category || "") + capitalizeFirstLetter(userData?.typeOfQuery || "");
     } else if (userData?.category === "HealthCenters"){
        if(userData?.typeOfQuery === "appointmentRequest"){
            queueCategory = "PrimaryHealthcareCenters";
         }else{
            queueCategory = "HealthCenters";
        }
     }else {
         queueCategory = capitalizeFirstLetter(userData?.category || "");
     }

     const payloadObject = {
         queueName: `${getLanguage()}${queueCategory}`,
         queueType: CHAT_APP.WORK_GROUP,
         participant: {
             name: userData.fullName,
             credentials: null,
         },
     };

     dispatch(queueState(payloadObject));
 };


  // This method will call startChat API
  const getStartChat = () => {
    const customInfo = `Phone : +${userData.contryCode}${userData.contactNo} ;WorkGroup : ${CHAT_APP.WORK_GROUP} ;TypeOf Query : ${getLanguage()}${userData?.typeOfQuery} ;Note : ${userData.queryDiscription} ;Email : ${userData.emailAddress}`;
    const capitalizeFirstLetter = (string) => {
      return string.charAt(0).toUpperCase() + string.slice(1);
    };

    let queueCategory = "";

    if (userData?.category === "generalInquiries") {
         if(userData?.typeOfQuery === "dubaiHealthInitiatives"){
            queueCategory = "DAHCInitiatives";
         }else{
            queueCategory = capitalizeFirstLetter(userData?.typeOfQuery || "");
         }
     } else if(userData?.category === "medicalFitness"){
         queueCategory = capitalizeFirstLetter(userData?.typeOfQuery || "");
     } else if (userData?.category === "shareFeedback") {
         queueCategory = capitalizeFirstLetter(userData?.category || "") + capitalizeFirstLetter(userData?.typeOfQuery || "");
     } else if (userData?.category === "HealthCenters"){
        if(userData?.typeOfQuery === "appointmentRequest"){
            queueCategory = "PrimaryHealthcareCenters";
         }else{
            queueCategory = "HealthCenters";
        }
     }else {
         queueCategory = capitalizeFirstLetter(userData?.category || "");
     }
    const payloadObject = {
      supportedContentTypes: `${CHAT_APP.CONTENT_TYPE}`,
      participant: {
        name: userData.fullName,
        credentials: "",
      },
      transcriptRequired: true,
      emailAddress: userData.emailAddress,
      phone: `+${userData.contryCode}${userData.contactNo}`,
      target: `${getLanguage()}${queueCategory}`,
      targetType: CHAT_APP.WORK_GROUP,
      clientToken: CHAT_APP.DEPRECATED,
      language: LANGUAGE.ENGLISH === getLanguage() ? LANGUAGE.EN : LANGUAGE.AR,
          customInfo, // Adding the customInfo field

    };
    dispatch(startChat(payloadObject));
  };

  // This method will call sendMessages API
  const sendMessage = () => {
    const requestObject = {
      participantId: participantId,
      payload: { message: message },
    };
    setMessage("");
    dispatch(sendMessages(requestObject));
  };

  const getReceivedMessages = () => {
    if (participantId !== "") {
      dispatch(getPoll(participantId));
    }
  };

  return (
    <div id="liveChat">
      <div className="chat-history">
        <ul>
          {receiveMessageList.length > 0 &&
            receiveMessageList?.map((receivedItem, index) => (
              <MessageView key={index} index={index} receivedItem={receivedItem} userData={userData} />
            ))}
          {isAgentTyping && (
            <li className="agent-typing-text">
              <p>{t("agent_is_typing")}</p>
            </li>
          )}
        </ul>
      </div>
      <div className="bottom-container">
        <StatusView />
        <div className="send-message-view">
          <SendMessageView
            message={message}
            setMessage={setMessage}
            sendMessage={sendMessage}
          />
          <div className="text-right p-3 chat-close-btn">
            <button
              className="btn btn-danger"
              onClick={() => setModalBody(MODAL_BODY.THANK_YOU)}
            >
              {t("close_chat")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LiveChat;
